export const authURLs = {
  // get authorization code
  code: (clientID: number, stateString: string) =>
    `/v1/oauth/authorize?client_id=${clientID}&response_type=code&state=${stateString}`,
  // fetch authorization token
  token: (clientID: number, secret: string, code: string) =>
    `/v1/oauth/token?grant_type=authorization_code&client_id=${clientID}&client_secret=${secret}&code=${code}`,
  tokenV2: '/v2/oauth/token',
  // refresh token
  refresh: (clientID: number, secret: string, token: string) =>
    `/v1/oauth/token?grant_type=refresh_token&client_id=${clientID}&client_secret=${secret}&refresh_token=${token}`,
  usedAccountTypes: (userId: number) => `/v1/accounts/users/${userId}/types`
};
